import { render, staticRenderFns } from "./ranking-result-card-actions.component.vue?vue&type=template&id=3699a726&scoped=true"
import script from "./ranking-result-card-actions.component.vue?vue&type=script&lang=ts"
export * from "./ranking-result-card-actions.component.vue?vue&type=script&lang=ts"
import style0 from "./ranking-result-card-actions.component.vue?vue&type=style&index=0&id=3699a726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3699a726",
  null
  
)

export default component.exports